import {
  checklistTemplateEditorMutationKeys,
  RequestTypes,
} from '@core/react-query/features/templates/checklistTemplates'
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { foldersKeys } from '@core/react-query/features/folders'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useCreateChecklistTemplate = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['createChecklistTemplate']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...checklistTemplateEditorMutationKeys.createChecklistTemplate,
    ...options,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: foldersKeys._def,
      })
    },
  })
}
